/**
 * Predefined specializations for PromptVan profiles.
 * Source of truth for allowed values - the DB CHECK constraint
 * (specializations_valid) must be updated via ALTER TABLE when
 * values are added/removed. No ENUM - just TEXT[] + CHECK.
 * @see db/migrations/legacy/20260308_profiles.sql
 */
export const SPECIALIZATIONS = [
  { value: 'prompt-engineering', label: 'Prompt Engineering' },
  { value: 'chatbot-design', label: 'Chatbot Design' },
  { value: 'image-generation', label: 'Image Generation' },
  { value: 'code-generation', label: 'Code Generation' },
  { value: 'content-writing', label: 'Content Writing' },
  { value: 'data-analysis', label: 'Data Analysis' },
  { value: 'voice-ai', label: 'Voice AI' },
  { value: 'agent-building', label: 'Agent Building' },
  { value: 'fine-tuning', label: 'Fine-Tuning' },
  { value: 'rag-systems', label: 'RAG Systems' },
  { value: 'ai-safety', label: 'AI Safety' },
  { value: 'multimodal-ai', label: 'Multimodal AI' },
] as const

/** Allowed value strings for DB storage */
export type SpecializationValue = typeof SPECIALIZATIONS[number]['value']

/** Array of allowed value strings - useful for Zod enum validation */
export const SPECIALIZATION_VALUES = SPECIALIZATIONS.map((s) => s.value) as [
  SpecializationValue,
  ...SpecializationValue[],
]
